/**
 * Тип элемента дерева с добавленным полем children
 */
export type TreeNode<T, ChildrenField extends string> = T & {
    [K in ChildrenField]: TreeNode<T, ChildrenField>[];
};

/**
 * Строит древовидную структуру из плоского массива элементов
 *
 * @param dataset - Плоский массив элементов
 * @param idField - Поле с уникальным идентификатором (по умолчанию 'ID')
 * @param parentField - Поле с идентификатором родителя (по умолчанию 'PARENT')
 * @param childrenField - Поле для массива дочерних элементов (по умолчанию 'CHILDREN')
 * @param fillOnlyNullChildrens - Если true, заполняет children только если они null
 * @returns Массив корневых элементов дерева с заполненными children
 */
export function treeBuild<
    T extends Record<string, any>,
    ChildrenField extends string = 'CHILDREN'
>(
    dataset: T[],
    idField: keyof T = 'ID' as keyof T,
    parentField: keyof T = 'PARENT' as keyof T,
    childrenField: ChildrenField = 'CHILDREN' as ChildrenField,
    fillOnlyNullChildrens = false
): TreeNode<T, ChildrenField>[] {

    const hashTable = Object.create(null);

    let haveNotNullChildrenField = false;

    dataset.forEach((node: any) => {
        haveNotNullChildrenField = haveNotNullChildrenField || !!node[childrenField];
        node[childrenField] = [];
        hashTable[node[idField]] = node;
    });

    if (haveNotNullChildrenField && fillOnlyNullChildrens) {
        return dataset as TreeNode<T, ChildrenField>[];
    }

    const dataTree: TreeNode<T, ChildrenField>[] = [];

    dataset.forEach((aData: any) => {

        const child = hashTable[aData[idField]];
        const parentId = child[parentField];

        if (parentId) {
            if (Array.isArray(parentId)) {
                parentId.forEach((id: any) => {
                    if (hashTable[id]) {
                        hashTable[id][childrenField].push(child);
                    }
                });
            } else {
                if (hashTable[parentId]) {
                    hashTable[parentId][childrenField].push(child);
                }
            }
        } else {
            dataTree.push(child);
        }
    });

    return dataTree;
}

export default treeBuild
